import { render } from "./form_management.html?vue&type=template&id=9e571c08&scoped=true&external"
import script from "./form_management.js?vue&type=script&lang=js&external"
export * from "./form_management.js?vue&type=script&lang=js&external"

import "./FormManagement.vue?vue&type=style&index=0&id=9e571c08&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e571c08"]])

export default __exports__